import { Model } from "@/models/base/model";

export class HealthCare extends Model {
  constructor(params: any = {}) {
    super(params);
  }

  // 疾患一覧取得
  async getDiseases(): Promise<any> {
    this.url = `/cms/health-care`;
    return await super.fetch();
  }

  // 疾患詳細取得
  async getDiseaseDetail(diseaseCode: string): Promise<any> {
    this.url = `/cms/health-care/detail/${diseaseCode}`;
    return await super.fetch();
  }
}
